// libs
import React, { memo, useMemo } from 'react';
import dayjs from 'dayjs';
// dls
import { Text } from '@swiggy-private/dls-web-core/dist/components/Text';
// components
import DatePicker from '@/components/DatePicker/DatePicker';
// styles
import styles from '../Schedule.module.scss';
// constants
import { DlsColorTokens, DlsFontVariants } from '@/constants/DLSTokens';
import { CampaignStatus } from '@local/typedefs/dist/protos/campaign/Campaign';
function DateSelector({ campaignStatus, currentCampaignEndDate, campaignStartDate, campaignEndDate, setCampaignStartDate, setCampaignEndDate, validationMessages, }) {
    const startDate = campaignStartDate
        ? dayjs(campaignStartDate).toDate()
        : undefined;
    const endDate = campaignEndDate
        ? dayjs(campaignEndDate).toDate()
        : undefined;
    const disabledCampaignStartDates = {
        before: dayjs().subtract(1, 'D').toDate(),
    };
    const disabledCampaignEndDates = useMemo(() => {
        let disabledDate = dayjs().subtract(1, 'day').toDate();
        if (campaignStatus === CampaignStatus.CAMPAIGN_STATUS_LIVE) {
            disabledDate = dayjs(currentCampaignEndDate).toDate();
        }
        else if (campaignStartDate) {
            disabledDate = dayjs(campaignStartDate).add(1, 'day').toDate();
        }
        return {
            before: disabledDate,
        };
    }, [startDate, campaignStatus, endDate]);
    const isStartDateInputDisabled = campaignStatus === CampaignStatus.CAMPAIGN_STATUS_LIVE ||
        campaignStatus === CampaignStatus.CAMPAIGN_STATUS_STOPPED;
    const isEndDateInputDisabled = campaignStatus === CampaignStatus.CAMPAIGN_STATUS_STOPPED;
    const onCampaignStartDateChange = (date) => {
        setCampaignStartDate(date);
        validateAndResetEndDate(date);
    };
    const onCampaignEndDateChange = (date) => {
        setCampaignEndDate(date);
    };
    const validateAndResetEndDate = (latestStartDate) => {
        if (!endDate || !latestStartDate) {
            return;
        }
        if (endDate < latestStartDate) {
            setCampaignEndDate(undefined);
        }
    };
    return (React.createElement("div", { className: styles.container },
        React.createElement("div", null,
            React.createElement("div", { className: styles.header },
                React.createElement(Text, { variant: DlsFontVariants.subheader_S1_Bold, color: DlsColorTokens.text_High_Emphasis, className: styles.headerTitle }, "Choose start and end date"),
                React.createElement(Text, { variant: DlsFontVariants.body_B1_Reg, color: DlsColorTokens.text_Med_Emphasis }, "Choose when your Ad should start and stop showing up on the platform"))),
        React.createElement("div", { className: styles.dateWrapper },
            React.createElement(DatePicker, { setValue: onCampaignStartDateChange, label: "Start date", placeholder: "Select start date", value: startDate, disabledDateMatcher: disabledCampaignStartDates, errorMsg: validationMessages.startDate, disabled: isStartDateInputDisabled }),
            React.createElement(DatePicker, { setValue: onCampaignEndDateChange, placeholder: "Select end date", label: "End date", value: endDate, defaultMonth: endDate !== null && endDate !== void 0 ? endDate : startDate, disabledDateMatcher: disabledCampaignEndDates, errorMsg: validationMessages.endDate, disabled: isEndDateInputDisabled }))));
}
export default memo(DateSelector);
